export default __webpack_public_path__ + "static/media/flag.fed10781.svg";